// Transient bottom-right "Saved" confirmation for write-throughs. Positive
// feedback so a stale failure banner can never masquerade as the verdict on
// a save that actually worked (Jason's 7/28 "changes not saved" report).
import { useEffect, useState } from 'react'
import { CheckCircle2 } from 'lucide-react'
import { useStore } from '@/store/useStore'

const SHOW_MS = 2400

export function SavedToast() {
  const ping = useStore((s) => s.savedPing)
  const failedCount = useStore((s) => s.failedSaves.length)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!ping) return
    setVisible(true)
    const t = setTimeout(() => setVisible(false), SHOW_MS)
    return () => clearTimeout(t)
  }, [ping])

  if (!ping || !visible) return null
  return (
    // Sits above the failure banner when both are present, never covers it.
    <div className={`stoast${failedCount ? ' stoast--lifted' : ''}`} role="status">
      <CheckCircle2 size={15} />
      <span><b>{ping.label}</b> saved</span>
    </div>
  )
}
